Namespace 'CustomerVisualMode'

class CustomerVisualMode.SharedSession extends Backbone.Model
  urlRoot: '/customer/visual_mode/shared_sessions'

  execute: ->
    @trigger('session:execution:pending')
    $.ajax
      url: @url() + '/execute'
      method: 'GET'
      contentType: 'application/json'
      success: (response) =>
        @trigger('session:execution', response)
